import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconTypes } from 'components/icon/icon.types';

import Icon from 'components/icon/icon';

import Typography from 'components/typography/typography';

import { createLocale } from 'locales';

import { useGetFreelancerDetails } from 'state/remote/remote-freelancer/use-get-freelancer-details';

const localize = createLocale('freelancerAvailableJobsLocales');
interface FooterItemProps {
  icon: IconTypes;
  title: string;
  link: string;
}

type FooterPropTypes = {
  className?: string;
};

const Footeritem: React.FC<FooterItemProps> = ({ icon, title, link }) => {
  return (
    <div className="w-1/4 m-3 flex flex-col items-center justify-center">
      <button
        type="button"
        className="w-full h-full flex flex-col items-center justify-center"
        onClick={() => {
          window.location.assign(link);
        }}
      >
        <Icon
          icon={icon}
          size={42}
          className=" text-body-medium md:text-page-subheading lg:text-title h-14 lg:h-20 w-14 lg:w-20 bg-transparent mb-1  lg:mb-3 fill-white"
        />
        <Typography as="h5" variant="body-large-bold">
          <p className="text-assistive md:text-body-large mt-1 md:mt-0 px-0 mx-0 lg:text-page-subheading h-4 md:h-auto">
            {title}
          </p>
        </Typography>
      </button>
    </div>
  );
};

const FreelancerFooter: React.FC<FooterPropTypes> = (props) => {
  const { className } = props;
  const { data, isLoading, error } = useGetFreelancerDetails();

  const containerClassName = twMerge(
    'fixed lg:hidden flex items-center justify-center bottom-0 h-24 mx-0 w-screen text-white bg-primary',
    className,
  );
  if (isLoading || !data || error)
    return <div className={containerClassName} />;

  const redirectLink =
    data && data.verified ? '/freelancer/ads/all/' : '/freelancer/ads/example/';

  return (
    <div className={containerClassName}>
      <Footeritem
        icon="bell"
        title={localize('toCallToAction')}
        link={redirectLink}
      />
      <Footeritem
        icon="suitcase"
        title={localize('assignments')}
        link="/freelancer/jobs/week/"
      />
      <Footeritem
        icon="calendar"
        title={localize('availability')}
        link="/freelancer/availability/"
      />
      <Footeritem
        icon="euro"
        title={localize('invoices')}
        link="/freelancer/invoice/open/"
      />
    </div>
  );
};

export default FreelancerFooter;
